export const Copy = ({ size = 20, className, bold = false }) => {
  return bold ? (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="5.33594"
        y="5.33301"
        width="8"
        height="8"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6641 5.33366V4.00033C10.6641 3.26395 10.0671 2.66699 9.33073 2.66699H3.9974C3.26102 2.66699 2.66406 3.26395 2.66406 4.00033V9.33366C2.66406 10.07 3.26102 10.667 3.9974 10.667H5.33073"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="6.66602"
        y="6.66602"
        width="10"
        height="10"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.334 6.66732V5.00065C13.334 4.08018 12.5878 3.33398 11.6673 3.33398H5.00065C4.08018 3.33398 3.33398 4.08018 3.33398 5.00065V11.6673C3.33398 12.5878 4.08018 13.334 5.00065 13.334H6.66732"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
